export default __webpack_public_path__ + "static/media/coun-room.86593edf.jpg";